<template>
  <div>
    <div class="bg-white pt-5 pl-5 pr-5 pb-3">
      <h3 class="text-center font-weight-bold pb-3"><span class="color-lightpink pr-2">
        {{feedbacks.length}}</span> Feedbacks received
      </h3>
      <feedbacks-filter v-model="filter" :feedbacks="feedbacks" class="text-right" />
      <hr class="mb-0" />
    </div>
    <feedbacks-list v-if="!loading" :feedbacks="filteredFeedbacks" />
    <div v-else class="text-center p-5">
      <b-spinner variant="primary" label="Loading..." />
    </div>
  </div>
</template>

<script>
import FeedbacksList from './FeedbacksList.vue'
import FeedbacksFilter from './FeedbacksFilter.vue'
import { FEEDBACK_TYPE } from '@/helpers/types'

export default {
  name: 'Feedbacks',

  props: {
    feedbacks: {
      type: Array,
      default: () => ([])
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filter: {
        [FEEDBACK_TYPE.TEAM]: true,
        [FEEDBACK_TYPE.MANAGER]: true,
        [FEEDBACK_TYPE.EXTERNAL]: true,
        [FEEDBACK_TYPE.PEER]: true
      }
    }
  },

  computed: {
    filteredFeedbacks() {
      return this.feedbacks.filter(p => this.filter[p.type])
    }
  },

  components: {
    FeedbacksList,
    FeedbacksFilter
  }
}
</script>
